import { Store } from '@sama/app-state';
import { keyBy, mapValues } from '@sama/micro-dash';
import { ShapeLocationState2D } from '../../../../../cross-team-shared/annotation/shared/state/shape-location-state';
import { ShapeState2D } from '../../../../../cross-team-shared/annotation/shared/state/shape-state';
import {
  arrayToSubpointSelection,
  selectionToArray,
} from '../../../../../cross-team-shared/misc-utils';
import { getShapesWithSubpointsForEventTracking } from '../../../event-utils';
import { AbstractVectorTranslationHelper } from './abstract-vector-translation-helper';

export class MultipleSubpointTranslationHelper extends AbstractVectorTranslationHelper {
  protected method = 'drag_subpoint';

  protected getMovableSubpointIndexes(
    shapeStore: Store<ShapeState2D>,
    location: ShapeLocationState2D,
  ) {
    const points = location.points;
    return selectionToArray(
      this.store.state().selection[shapeStore.state().index],
    ).filter((subpointIndex) => subpointIndex < points.length);
  }

  protected override getAffectedShapesForEventTracking() {
    const selection = mapValues(
      keyBy(this.getAllMovableInfo(), (movableInfo) =>
        movableInfo.shapeStore.state().index.toString(),
      ),
      (movableInfo) => arrayToSubpointSelection(movableInfo.subpointIndexes),
    );
    return getShapesWithSubpointsForEventTracking(
      this.store.state().shapes,
      selection,
    );
  }
}
